import { MARQUEE_ITEMS } from "@/lib/data";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="marquee-ribbon"
      className="overflow-hidden border-y border-slate-200 bg-white py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-xl font-bold uppercase tracking-wide text-ink/80 sm:text-2xl">
              {item}
            </span>
            <span className="mx-10 h-2.5 w-2.5 rotate-45 bg-royal/70" aria-hidden />
          </span>
        ))}
      </div>
    </div>
  );
};
